import { ChangeDetectionStrategy, Component} from '@angular/core';
import { AbstractFormComponent, FieldTextComponent, FieldNumberComponent, FieldTextAreaComponent, FieldDateComponent } from '@spike/scaffolds';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-wallet-form',
  providers:[],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CommonModule, FormsModule, FieldTextComponent, FieldNumberComponent, FieldNumberComponent, FieldTextAreaComponent, FieldDateComponent],
  templateUrl: './wallet-form.html'
})

export class WalletFormComponent extends AbstractFormComponent{
}
  

